import React, { useEffect, useState } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import DatePopUp from "./date_popup.js";
import TaskPopUp from "./task_popup.js";
import "../styles/history_popup.css";
import { secretKey } from "../.././data";
import Loading from "../helpers/loading_component.js";

const MySwal = withReactContent(Swal2);

const HistoryPopUp = (props) => {
  const [tasks, setTasks] = useState([]);
  const [hearings, setHearings] = useState([]);
  const [showDate, setShowDate] = useState(false);
  const [dateId, setDateId] = useState("");
  const [showTask, setShowTask] = useState(false);
  const [taskId, setTaskId] = useState("");
  const [loading, setLoading] = useState(false);

  const closeDatePopUp = (e) => {
    setShowDate(!showDate);
    setDateId("");
    getData();
  };

  const showDatePopUp = (e) => {
    setDateId(e.target.value);
    setShowDate(true);
    setShowTask(false);
  };

  const closeTaskPopUp = (e) => {
    setShowTask(!showTask);
    getData();
  };

  const showTaskPopUp = (e) => {
    setTaskId(e.target.value);
    setShowTask(true);
    setShowDate(false);
  };

  const fetchHearingsData = async (id) => {
    var body = {
      name: props.clientName,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getHearingsName", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setHearings(data);
      })
      .catch((error) => {});
  };

  const fetchTasksData = async (id) => {
    var body = {
      name: props.clientName,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getTasksName", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setTasks(data);
        setLoading(false);
      })
      .catch((error) => {});
  };

  const getData = () => {
    fetchHearingsData();
    fetchTasksData();
  };

  useEffect(() => {
    setLoading(true);
    getData();
  }, []);

  return (
    <>
      {showDate ? (
        <>
          <DatePopUp
            dateID={dateId}
            hearingsData={props.hearingsData}
            hearingsSheetData={props.hearingsSheetData}
            tasksData={props.tasksData}
            tasksSheetData={props.tasksSheetData}
            close={closeDatePopUp}
            lawyersData={props.lawyersData}
            refreshData={props.refreshData}
            user={props.user}
            courtsData={props.courtsData}
            banksData={props.banksData}
            usersData={props.usersData}
            resultsData={props.resultsData}
            tasksTypesData={props.tasksTypesData}
            history={true}
            checkPermissions={props.checkPermissions}
            team={props.team}
            hearingsTeam2Data={props.hearingsTeam2Data}
            hearingsTeam2SheetData={props.hearingsTeam2SheetData}
            tasksTeam2Data={props.tasksTeam2Data}
            tasksTeam2SheetData={props.tasksTeam2SheetData}
            archDateTeam2={props.archDateTeam2}
            archDate={props.archDate}
            filesData={props.filesData}
            user={props.user}
            logClientAction={props.logClientAction}
            substitutesData={props.substitutesData}
          />
        </>
      ) : (
        ""
      )}
      {showTask ? (
        <>
          <TaskPopUp
            taskID={taskId}
            hearingsData={props.hearingsData}
            tasksData={props.tasksData}
            tasksSheetData={props.tasksSheetData}
            closeTaskPopUp={closeTaskPopUp}
            lawyersData={props.lawyersData}
            refreshData={props.refreshData}
            user={props.user}
            courtsData={props.courtsData}
            banksData={props.banksData}
            usersData={props.usersData}
            resultsData={props.resultsData}
            tasksTypesData={props.tasksTypesData}
            history={true}
            checkPermissions={props.checkPermissions}
            team={props.team}
            hearingsTeam2Data={props.hearingsTeam2Data}
            hearingsTeam2SheetData={props.hearingsTeam2SheetData}
            tasksTeam2Data={props.tasksTeam2Data}
            tasksTeam2SheetData={props.tasksTeam2SheetData}
            archTasksTeam2={props.tasksArchTeam2SheetData}
            archTasks={props.archTasks}
            filesData={props.filesData}
            user={props.user}
            logClientAction={props.logClientAction}
            substitutesData={props.substitutesData}
          />
        </>
      ) : (
        ""
      )}
      {showDate || showTask ? (
        ""
      ) : (
        <div className="mainContainerDatePopUp">
          {loading ? (
            <Loading id="popUpLoading" />
          ) : (
            <>
              <div className="closeBox">
                <button className="closeClientButton" onClick={props.close}>
                  X
                </button>
              </div>
              <div className="hearingTitle">
                Historia klienta{" "}
                <span className="highlight">{props.clientName}</span>
              </div>
              <div className="hearings_history_box">
                <div className="hearings_history_title">ROZPRAWY</div>
                <div className="hearings_data_box">
                  <div
                    id="hearings_data_header"
                    className="hearings_data_box_row"
                  >
                    <div className="hearings_data_box_col">Data rozprawy</div>
                    <div className="hearings_data_box_col">Bank</div>
                    <div className="hearings_data_box_col">Sygnatura</div>
                    <div className="hearings_data_box_col">Temat</div>
                    <div className="hearings_data_box_col"></div>
                  </div>
                  {hearings.map((el) => (
                    <>
                      <div className="hearings_data_box_row">
                        <div className="hearings_data_box_col">{el.date}</div>
                        <div className="hearings_data_box_col">{el.bank}</div>
                        <div className="hearings_data_box_col">{el.sygn}</div>
                        <div className="hearings_data_box_col">
                          {el.subject}
                        </div>
                        <div className="hearings_data_box_col">
                          <button
                            className="viewButton"
                            value={el.id}
                            onClick={showDatePopUp}
                          >
                            PRZEJDŹ
                          </button>
                        </div>
                      </div>
                    </>
                  ))}
                </div>
              </div>
              <div className="hearings_history_box">
                <div className="hearings_history_title">ZADANIA</div>
                <div className="hearings_data_box">
                  <div
                    id="hearings_data_header"
                    className="hearings_data_box_row"
                  >
                    <div className="hearings_data_box_col">Data startowa</div>
                    <div className="hearings_data_box_col">
                      Termin wykonania
                    </div>
                    <div className="hearings_data_box_col">Zadanie</div>
                    <div className="hearings_data_box_col">
                      Osoba odpowiedzialna
                    </div>
                    <div className="hearings_data_box_col"></div>
                  </div>
                  {tasks.map((el) => (
                    <>
                      <div className="hearings_data_box_row">
                        <div className="hearings_data_box_col">
                          {el.start_date}
                        </div>
                        <div className="hearings_data_box_col">
                          {el.final_date}
                        </div>
                        <div className="hearings_data_box_col">{el.task}</div>
                        <div className="hearings_data_box_col">
                          {el.responsible}
                        </div>
                        <div className="hearings_data_box_col">
                          <button
                            className="viewButton"
                            value={el.id}
                            onClick={showTaskPopUp}
                          >
                            PRZEJDŹ
                          </button>
                        </div>
                      </div>
                    </>
                  ))}
                </div>
              </div>
            </>
          )}
        </div>
      )}
    </>
  );
};

export default HistoryPopUp;
